import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-113" data-mp="2lzhgzrni1l58">
      <div className="mx-auto max-w-6xl" data-id="element-114" data-mp="2h427td0fsdf5">
        <SectionHeading id="inside-heading" eyebrow="See What's Inside" title={<>
              Don't Just Read About a Technique. <Accent data-id="element-116" data-mp="236ne3w35hjhd">Teach It Visually.</Accent>
            </>} body="Visual teaching pages that help students see the difference between correct and incorrect technique." data-id="element-115" data-mp="2d3s0nx0wrgyp" />

        <div className="mt-12" data-id="element-117" data-mp="1u68myg3i9a5y">
          <InsidePagesCarousel data-id="element-118" data-mp="1u70ixs10l9wr" />
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-119" data-mp="1u8bmbqqjsfnc">
          This isn't a collection of generic nail ebooks. It's teaching material designed to be used
          in <Accent data-id="element-120" data-mp="23krbacggn21s">real nail classes.</Accent>
        </p>
      </div>
    </section>;
}